import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Horse, Calendar, Trophy } from '@phosphor-icons/react';

export const StatsGrid = ({ showsCount, entriesCount, organization, isRider }) => {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-6 mb-8 sm:mb-12">
      <div data-testid="stats-shows" className="bg-[#161616] border border-[#262626] rounded-lg p-4 sm:p-6">
        <div className="flex items-center gap-3 sm:gap-4">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#0096FF]/10 rounded-lg flex items-center justify-center flex-shrink-0">
            <Calendar size={20} className="text-[#0096FF]" weight="duotone" />
          </div>
          <div>
            <p className="text-[#9E9E9E] text-xs sm:text-sm">Total Shows</p>
            <p className="text-2xl sm:text-3xl font-bold text-white" style={{fontFamily: 'Outfit'}}>{showsCount}</p>
          </div>
        </div>
      </div>

      {isRider && (
        <div data-testid="stats-entries" className="bg-[#161616] border border-[#262626] rounded-lg p-4 sm:p-6">
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#00D4FF]/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Horse size={20} className="text-[#00D4FF]" weight="duotone" />
            </div>
            <div>
              <p className="text-[#9E9E9E] text-xs sm:text-sm">My Entries</p>
              <p className="text-2xl sm:text-3xl font-bold text-white" style={{fontFamily: 'Outfit'}}>{entriesCount}</p>
            </div>
          </div>
          <button
            data-testid="view-rider-history-btn"
            onClick={() => navigate('/rider/history')}
            className="mt-3 w-full text-center px-3 py-2 bg-[#0096FF]/10 hover:bg-[#0096FF]/20 text-[#0096FF] text-xs sm:text-sm font-semibold rounded-md transition-colors"
          >
            View Stats & History
          </button>
        </div>
      )}

      {organization && (
        <div data-testid="stats-subscription" className="bg-[#161616] border border-[#262626] rounded-lg p-4 sm:p-6 col-span-2 md:col-span-1">
          <div className="flex items-center gap-3 sm:gap-4">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#34C759]/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Trophy size={20} className="text-[#34C759]" weight="duotone" />
            </div>
            <div>
              <p className="text-[#9E9E9E] text-xs sm:text-sm">Plan</p>
              <p className="text-lg sm:text-xl font-bold text-white" style={{fontFamily: 'Outfit'}}>{organization.subscription_plan}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
